import objectPath from 'object-path';
import { Engine } from 'json-rules-engine';
import { store } from '../../store';

export const validateAddons = ({ filteredAddons, page, area }) =>
  filteredAddons.reduce((promoCollection, promo) => {
    const promoLocation = promo?.location;
    return promoLocation?.area &&
      promoLocation?.page &&
      promoLocation.area.includes(area) &&
      promoLocation.page.includes(page)
      ? [...promoCollection, promo]
      : promoCollection;
  }, []);

export const collectFacts = (obj, result = {}) => {
  Object.keys(obj).forEach((key) => {
    if (key === 'fact') {
      result[obj[key]] = obj[key];
    } else if (typeof obj[key] === 'object') {
      collectFacts(obj[key], result);
    }
  });
  return result;
};

export const evaluateRules = async (promos) => {
  const state = store.getState();

  const evaluatedRules = await Promise.all(
    promos.map(async (promo) => {
      if (!promo?.rule) return promo;

      const { rule } = promo;
      const engine = new Engine();
      engine.addRule(rule);

      const facts = collectFacts(rule);
      Object.entries(facts).forEach(([key, value]) => {
        facts[key] = objectPath.get(state, value);
      });

      const outcome = await engine.run(facts);
      return outcome?.events?.length > 0 ? promo : null;
    }),
  );

  return evaluatedRules.filter(Boolean);
};
